import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
/**
 * @param {ErrorResponse} errorResponse
 * @param {ErrorDataMessageConfig} errorDataMessage
 *
 * @returns {Promise<null|string>}
 */

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(errorResponse, errorDataMessage) {
    var _ref2, _ref2$error, error, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = errorResponse.getData() || {}, _ref2$error = _ref2.error, error = _ref2$error === void 0 ? null : _ref2$error;
            message = isString(error) || isNumber(error) ? errorDataMessage.getValueByKey(error) : null;

            if (!(!error || message === null)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", null);

          case 4:
            if (!isFunction(message)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", message(errorResponse));

          case 6:
            return _context.abrupt("return", message);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();